import React from 'react';

const AIPredictiveCharting = () => {
  return (
    <div className="sh_cardBox sh_cardbggradient h-auto position-relative">
      <div className="sh_blobbg"></div>
      <div className="sh_blobbg">
        {/* Background SVG can be added here if needed */}
      </div>
      <div className="sh_cardHeader pb-0">
        <div className="d-flex align-items-center">
          <span className="pr-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M12 16.0019C12 13.7918 13.7916 12.0002 16.0017 12.0002C13.7916 12.0002 12 10.2086 12 7.99854C12 10.2086 10.2084 12.0002 7.99835 12.0002C10.2084 12.0002 12 13.7918 12 16.0019Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M21.0037 12.0001C21.0037 16.9727 16.9726 21.0038 12 21.0038C7.02733 21.0038 2.99622 16.9727 2.99622 12.0001C2.99622 7.02745 7.02733 2.99634 12 2.99634" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              <path fillRule="evenodd" clipRule="evenodd" d="M19.0029 7.99835C19.0029 6.34081 20.3466 4.9971 22.0041 4.9971C20.3466 4.9971 19.0029 3.65339 19.0029 1.99585C19.0029 3.65339 17.6592 4.9971 16.0016 4.9971C17.6592 4.9971 19.0029 6.34081 19.0029 7.99835Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </span>
          <h6 className="text-md font-weight-bold mb-0">AI - Predictive Charting</h6>
        </div>
      </div>
      <div className="sh_cardBody">
        <div className="d-flex flex-column">
          <div className="form-check mb-2">
            <input type="checkbox" className="sh_checkboxnew form-check-input" id="aiPredictiveCharting1" />
            <label className="form-check-label p2-light mb-0" htmlFor="aiPredictiveCharting1">
              Suggest MRI if pain persists
            </label>
          </div>
        </div>
        <div className="d-flex flex-column">
          <div className="form-check mb-2">
            <input type="checkbox" className="sh_checkboxnew form-check-input" id="aiPredictiveCharting2" />
            <label className="form-check-label p2-light mb-0" htmlFor="aiPredictiveCharting2">
              Xray - Chest 3V
            </label>
          </div>
        </div>
        <div className="d-flex flex-column">
          <div className="form-check mb-2">
            <input type="checkbox" className="sh_checkboxnew form-check-input" id="aiPredictiveCharting3" />
            <label className="form-check-label p2-light mb-0" htmlFor="aiPredictiveCharting3">
              Recommend physiotherapy referral
            </label>
          </div>
        </div>
        <div className="d-flex flex-column">
          <div className="form-check mb-2">
            <input type="checkbox" className="sh_checkboxnew form-check-input" id="aiPredictiveCharting4" />
            <label className="form-check-label p2-light mb-0" htmlFor="aiPredictiveCharting4">
              Pattern detected: Recurrent hip injury
            </label>
          </div>
        </div>
      </div>
      <div className="sh_cardFooter border-0" style={{ zIndex: 2 }}>
        <a className="btn btn-light sh_btnlight">Accept</a>
      </div>
    </div>
  );
};

export default AIPredictiveCharting;


